import { Link, LinkProps } from "react-router-dom";

export const TextLink = ({
  text,
  className,
  onClick = () => [],
  disabled,
  to,
  ...props
}: {
  text: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  to: string;
} & LinkProps) => {
  return (
    <Link
      {...props}
      to={to}
      className={`text-pry-green-200 font-medium 
      hover:text-pry-dark-green-100
      no-underline
      ${className}
      ${
        disabled &&
        "hover:!cursor-not-allowed text-pry-green-200/50 hover:text-pry-green-200/50 "
      }
      transition-all
      `}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
    >
      {text}
    </Link>
  );
};
